// components/nav/index

import transitionend from "@giantpeach/transition-end";

function Navigation() {
    this.nav = document.querySelector(".nav");
    this.menuButton = document.querySelector(".menu-button");
    // this.submenus = document.querySelectorAll(".sub-menu");

    // if (this.submenus.length > 0) {
    //     for (var i = 0; i < this.submenus.length; i++) {
    //         this.submenus[i].insertAdjacentHTML("beforebegin", "<div class='nav__subnav-revealer'><i class='fa fa-chevron-left'></i></div>");
    //         var revealer = this.submenus[i].previousElementSibling;

    //         revealer.addEventListener("click", function () {
    //             this.classList.toggle("is-open");
    //             jQuery(this).next("ul").slideToggle(500);
    //         });
    //     }
    // }

    this.eventListeners();
}

Navigation.prototype.eventListeners = function () {
    this.events = {
        body: this.bodyClick.bind(this),
        transitionend: this.transitionEnd.bind(this),
    };
    this.menuButton.addEventListener("click", this.onClick.bind(this), false);
    this.nav.addEventListener("click", function (e) {
        e.stopPropagation();
    });
};

Navigation.prototype.onClick = function (e) {
    e.stopPropagation();
    this.menuButton.classList.toggle("is-open");
    this.nav.classList.toggle("is-open");
    document.body.classList.toggle("is-menu-open");

    this.nav.addEventListener(transitionend, this.events.transitionend);
};

Navigation.prototype.bodyClick = function () {
    this.menuButton.classList.remove("is-open");
    this.nav.classList.remove("is-open");
    document.body.classList.remove("is-menu-open");

    document.removeEventListener("click", this.events.body);
};

Navigation.prototype.transitionEnd = function () {
    document.addEventListener("click", this.events.body);
    this.nav.removeEventListener(transitionend, this.events.transitionend);
};

export default Navigation;



// WEBPACK FOOTER //
// ./js/components/nav/index.js